/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate are the conversions?`)
};

const es_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan precisas son las conversiones?`)
};

const de_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau sind die Umrechnungen?`)
};

const nl_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig zijn de conversies?`)
};

const fr_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la précision des conversions ?`)
};

const it_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto sono accurate le conversioni?`)
};

const pt_br2_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão precisas são as conversões?`)
};

const pt_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a precisão das conversões?`)
};

const ja_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換の正確さはどのくらいですか?`)
};

const zh_uc_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq1_q", locale)
	if (locale === "en") return en_uc_hub_faq1_q(inputs)
	if (locale === "es") return es_uc_hub_faq1_q(inputs)
	if (locale === "de") return de_uc_hub_faq1_q(inputs)
	if (locale === "nl") return nl_uc_hub_faq1_q(inputs)
	if (locale === "fr") return fr_uc_hub_faq1_q(inputs)
	if (locale === "it") return it_uc_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq1_q(inputs)
	if (locale === "pt") return pt_uc_hub_faq1_q(inputs)
	if (locale === "ja") return ja_uc_hub_faq1_q(inputs)
	return zh_uc_hub_faq1_q(inputs)
};